
















































import { Component, Prop, Provide, Watch, Mixins } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class ChartRawPhaseWalkAdvanced extends Mixins(MixinChartRaw) {
  @Provide() backgroundsColor: string[] = ['#FF5E13', '#FFBE13', '#25C090', '#FFBE13', '#FF5E13'];
  @Provide() data: any = [];

  @Watch('values', { immediate: true, deep: true })
  onValuesChange() {
    this.data = [this.stride_duration, this.stride_length, this.swing, this.stance];
  }

  get stride_duration() {
    const left =
      this.$pdc.helper!.secToMs(this.values.left.aggregates.swing_time.avg) +
      this.$pdc.helper!.secToMs(this.values.left.aggregates.stance_time.avg);
    const right =
      this.$pdc.helper!.secToMs(this.values.right.aggregates.swing_time.avg) +
      this.$pdc.helper!.secToMs(this.values.right.aggregates.stance_time.avg);
    return {
      unit: 'ms',
      name: 'stride-duration',
      left: parseFloat(left.toFixed(0)),
      right: parseFloat(right.toFixed(0)),
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'PRO_SUP',
        'stride',
        'abs',
      ),
    };
  }
  get stride_length() {
    const left = this.values.left.aggregates.stride_length.avg * 100;
    const right = this.values.right.aggregates.stride_length.avg * 100;
    return {
      unit: 'cm',
      name: 'stride-length',
      left: parseFloat(left.toFixed(0)),
      right: parseFloat(right.toFixed(0)),
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'GENERAL',
        'stride_length',
        'abs',
      ),
    };
  }
  get swing() {
    const left = this.$pdc.helper!.secToMs(this.values.left.aggregates.swing_time.avg);
    const right = this.$pdc.helper!.secToMs(this.values.right.aggregates.swing_time.avg);
    return {
      unit: 'ms',
      name: 'swing-time',
      left: parseFloat(left.toFixed(0)),
      right: parseFloat(right.toFixed(0)),
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'PRO_SUP',
        'swing',
        'abs',
      ),
    };
  }
  get stance() {
    const left = this.$pdc.helper!.secToMs(this.values.left.aggregates.stance_time.avg);
    const right = this.$pdc.helper!.secToMs(this.values.right.aggregates.stance_time.avg);
    return {
      unit: 'ms',
      name: 'contact-time',
      left: parseFloat(left.toFixed(0)),
      right: parseFloat(right.toFixed(0)),
      ranges: this.$pdc.helper!.refint.getRange(
        this.patient!.infos.gender,
        this.$moment().diff(this.patient!.infos.birthDate, 'years', false),
        'PRO_SUP',
        'stance',
        'abs',
      ),
    };
  }

  valuePosition(val: any, side: string, ranges: any) {
    const isRightSide = side === 'right';
    const percentvalue = ((val - ranges.extremMin) * 100) / (ranges.extremMax - ranges.extremMin);
    if (percentvalue < 0) return isRightSide ? 'calc(100% - 25px)' : 'calc(0% - 25px)';
    if (percentvalue > 100) return isRightSide ? 'calc(0% - 25px)' : 'calc(100% - 25px)';
    return isRightSide ? `calc(100% - ${percentvalue}% - 25px)` : `calc(${percentvalue}% - 25px)`;
  }
  valueStatut(val: any, ranges: any) {
    switch (true) {
      case val >= ranges.base.min && val <= ranges.base.max:
        return '#25C090';
      case val >= ranges.minRange.min && val <= ranges.minRange.max:
      case val >= ranges.maxRange.min && val <= ranges.maxRange.max:
        return '#FFBE13';
      default:
        return '#FF5E13';
    }
  }
}
